<div class="error-view-container">
  <mat-icon [svgIcon]="option.icon" class="error-view-icon"></mat-icon>
  <span class="error-view-title">
    {{ option.title }}
  </span>
  <span *ngIf="option.description" class="error-view-description">
    {{ option.description }}
  </span>
</div>
